<hlm-date-picker
  class="w-full min-w-0 max-w-full [&_ng-icon]:text-text-muted [&_ng-icon]:[--ng-icon__size:1rem]"
  [buttonId]="inputId()"
  [date]="dateValue()"
  [disabled]="controlDisabled"
  [formatDate]="formatDate"
  autoCloseOnSelect
  (dateChange)="handleDateChange($event)"
>
  Select date
</hlm-date-picker>
